import { IProject } from 'spw-redux/modules/projects/types';
import * as constants from '../../../constants';

export const initialProjectProfile: IProject = {
  buildings: [],
  projectName: 'project name',
  projectNumber: '',
  city: '',
  state: '',
  type: constants.EXISTING_SITE_ANALYSIS,
  insertedAt: null,
  numberOfDepartments: 0,
};
